import { colorMapping, booleanMapping, genderMapping } from 'features/ahcr-events/types/ahcr-event.types';
import { Tag } from 'primereact/tag'

interface PersonInfoCardProps {
  metadata: Record<string, string>
}

const ColorField = ({ label, colorKey }: { label: string; colorKey: string }) => (
  <div className='detail-item'>
    <span className='detail-label'><i className='pi pi-palette mr-1' />{label}:</span>
    <span className='detail-value'>
      <div className='color-tag'>
        <span className={`color-indicator events-color-${colorKey.toLowerCase()}`} />
        <span>
          {colorMapping[colorKey.toLowerCase() as keyof typeof colorMapping] || colorKey}
        </span>
      </div>
    </span>
  </div>
)

const BooleanField = ({
  label,
  icon,
  value,
  trueySeverity,
}: {
  label: string
  icon: string
  value: string
  trueySeverity: 'success' | 'info' | 'warning'
}) => (
  <div className='detail-item'>
    <span className='detail-label'><i className={`${icon} mr-1`} />{label}:</span>
    <span className='detail-value'>
      <Tag
        severity={value === 'true' || value === 'yes' ? trueySeverity : 'danger'}
        value={booleanMapping[value.toLowerCase() as keyof typeof booleanMapping] || 'Desconhecido'}
        icon={icon}
      />
    </span>
  </div>
)

const PersonInfoCard = ({ metadata }: PersonInfoCardProps) => (
  <div className='detail-card'>
    <h4>
      <i className='pi pi-user mr-2' />
      Informações da Pessoa
    </h4>
    <div className='detail-grid'>
      {metadata.Gender && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-user mr-1' />Gênero:</span>
          <span className='detail-value'>
            <Tag
              severity={
                metadata.Gender.toLowerCase() === 'male'
                  ? 'info'
                  : metadata.Gender.toLowerCase() === 'female'
                    ? 'warning'
                    : null
              }
              value={
                genderMapping[metadata.Gender.toLowerCase() as keyof typeof genderMapping] ||
                'Desconhecido'
              }
              icon='pi pi-user'
            />
          </span>
        </div>
      )}

      {metadata.Hat !== undefined && (
        <BooleanField label='Chapéu' icon='pi pi-tag' value={metadata.Hat} trueySeverity='success' />
      )}

      {metadata.Age && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-hourglass mr-1' />Idade Estimada:</span>
          <span className='detail-value'>{metadata.Age} anos</span>
        </div>
      )}

      {metadata.TrousersColor && <ColorField label='Cor da Calça' colorKey={metadata.TrousersColor} />}
      {metadata.JacketColor && <ColorField label='Cor da Blusa' colorKey={metadata.JacketColor} />}
      {metadata.ShirtColor && <ColorField label='Cor da Camisa' colorKey={metadata.ShirtColor} />}

      {metadata.Height && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-arrows-v mr-1' />Altura Estimada:</span>
          <span className='detail-value'>{metadata.Height} cm</span>
        </div>
      )}

      {metadata.Weight && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-stop-circle mr-1' />Peso Estimado:</span>
          <span className='detail-value'>{metadata.Weight} kg</span>
        </div>
      )}

      {metadata.HairColor && <ColorField label='Cor do Cabelo' colorKey={metadata.HairColor} />}
      {metadata.SkinColor && <ColorField label='Cor da Pele' colorKey={metadata.SkinColor} />}

      {metadata.Glasses && (
        <BooleanField label='Óculos' icon='pi pi-eye' value={metadata.Glasses} trueySeverity='info' />
      )}

      {metadata.Mask && (
        <BooleanField label='Máscara' icon='pi pi-tag' value={metadata.Mask} trueySeverity='warning' />
      )}

      {metadata.Beard && (
        <BooleanField label='Barba' icon='pi pi-user' value={metadata.Beard} trueySeverity='info' />
      )}

      {metadata.Emotion && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-heart mr-1' />Emoção:</span>
          <span className='detail-value'>{metadata.Emotion}</span>
        </div>
      )}

      {metadata.Pose && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-user mr-1' />Postura:</span>
          <span className='detail-value'>{metadata.Pose}</span>
        </div>
      )}

      {metadata.Activity && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-cog mr-1' />Atividade:</span>
          <span className='detail-value'>{metadata.Activity}</span>
        </div>
      )}

      {metadata.Accessories && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-shopping-bag mr-1' />Acessórios:</span>
          <span className='detail-value'>{metadata.Accessories}</span>
        </div>
      )}
    </div>
  </div>
)

export default PersonInfoCard
